<template>
  <v-navigation-drawer
    v-model="drawer"
    @input="onClose"
    right
    app
    temporary
    width="600"
    class="pa-4"
  >
    <p class="title" @click="close()">
      {{ id ? "Alteração" : "Cadastro" }} de auxiliar
      <v-btn icon class="float-right">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </p>
    <v-divider class="mb-4"></v-divider>

    <FormularioGerenciarAuxiliar
      ref="formularioGerenciarAuxiliar"
      @salvar="this.salvar"
      :id="id"
    />
  </v-navigation-drawer>
</template>

<script>
import { api } from "../../../../api";
import FormularioGerenciarAuxiliar from "../forms/FormularioGerenciarAuxiliar.vue";

export default {
  name: "IziManNavigationDrawerGerenciarAuxiliar",
  components: { FormularioGerenciarAuxiliar },
  data() {
    return {
      id: null,
      drawer: false,
    };
  },
  methods: {
    show(id = null) {
      this.id = id;
      this.drawer = true;
    },

    close() {
      this.drawer = false;
    },

    onClose(event) {
      if (!event) {
        this.$refs.formularioGerenciarAuxiliar.$refs.form.reset();
      }
    },

    async salvar(body) {
      try {
        const response = !this.id
          ? await api.post("/helper", body)
          : await api.put(`/helper/${this.id}`, body);

        if (response.data) {
          this.$root.GlobalMessage.success("Operação realizada com sucesso!");
          this.$emit("salvo");
          this.close();
        } else this.$root.GlobalMessage.error("Erro ao cadastrar Auxiliar!");
      } catch (err) {
        this.$root.GlobalMessage.error(
          "Erro ao realizar requisição, entre em contato com o administrador!"
        );
      }
    },
  },
};
</script>
